import { StringSchema } from 'yup'

export default function (this: StringSchema, message: string) {
  return this.test('atLeastOneCharacter', message, (value) => /[a-z]+/i.test(value))
}
